import React from 'react'
import classNames from 'classnames'
import { useNavigationContext } from '#src/components/Header/StandardHeader/NavigationContext'
import { FlatDepartment } from '../../../../types'
import ArrowRight from '#src/components/Header/StandardHeader/icons/arrow-right.svg'
import styles from './styles.css'

interface DepartmentsColumnProps {
  flatDepartments: FlatDepartment[]
}

const DepartmentsColumn: React.FC<DepartmentsColumnProps> = ({ flatDepartments }) => {
  const navContext = useNavigationContext()

  return (
    <div className={styles.column}>
      <div className={styles.departments}>
        {flatDepartments.map(flatDepartment => {
          return (
            <span
              className={classNames(styles.department, {
                [styles.activeDepartment]:
                  navContext?.activeDepartmentSlug === flatDepartment.referenceSlug
              })}
              onClick={e => {
                e.stopPropagation()

                navContext?.onSetActiveDepartmentSlug(flatDepartment.referenceSlug)
              }}
              key={`${flatDepartment.referenceSlug || ''}${flatDepartment.slug}`}
            >
              <div className={styles.navItemHighlight}>
                <div className={styles.navItemHighlightLabel}>{flatDepartment.displayName}</div>
                <ArrowRight className={styles.navItemHighlightArrow} />
              </div>
            </span>
          )
        })}
      </div>
    </div>
  )
}

export default DepartmentsColumn
